import { useAuth } from '@/features/auth/auth-context'
import { selectedRelease } from '@/lib/release-channel'
import './release-banner.css'

export function ReleaseBanner() {
  const { profile } = useAuth()
  if (profile?.user.role !== 'admin' || selectedRelease()?.channel !== 'preview') return null
  return <aside className="release-banner" aria-label="Release environment">
    <strong>Admin preview · Live data</strong>
    <span>Changes here affect live records.</span>
  </aside>
}
